// extracted by mini-css-extract-plugin
module.exports = {"loader":"accountsettings_loader__312Qw"};